import { OptionService } from "src/app/modules/option/option.service";
import { Component, OnInit, OnDestroy, DestroyRef, inject } from "@angular/core";
import { TimeService } from "@services/time.service";
import { MatDialogRef } from "@angular/material/dialog";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DialogContainerComponent } from "@components/dialog-container/dialog-container.component";
import { QRCodeComponent } from "angularx-qrcode";
import { NgOptimizedImage, UpperCasePipe } from "@angular/common";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
  selector: "app-mobile-tan",
  templateUrl: "./mobile-tan.component.html",
  styleUrls: ["./mobile-tan.component.scss"],
  imports: [DialogContainerComponent, QRCodeComponent, NgOptimizedImage, UpperCasePipe, TranslocoPipe]
})
export class MobileTanComponent implements OnInit, OnDestroy {
  optionService = inject(OptionService);
  private timeService = inject(TimeService);
  private dialogRef = inject<MatDialogRef<MobileTanComponent>>(MatDialogRef);
  private destroyRef = inject(DestroyRef);

  timeLeft = 300;
  tan: string = null;
  AuthenticationTime = "05:00";
  googlePlayStore: string;
  appleStore: string;
  hasError: boolean;
  private interval: ReturnType<typeof setInterval>;

  ngOnInit() {
    this.setMobileStoreImages();
    this.refreshTAN();
  }

  setMobileStoreImages() {
    this.googlePlayStore =
      "./assets/store-badges/" + (this.optionService.locale().includes("de") ? "google-play-badge_de.svg" : "google-play-badge_en.svg");
    this.appleStore =
      "./assets/store-badges/" + (!this.optionService.locale().includes("de") ? "apple-store-badge_de.svg" : "apple-store-badge_en.svg");
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  close() {
    this.dialogRef.close();
  }

  startTimer() {
    let timer = this.timeLeft,
      minutes: number,
      seconds: number;
    return setInterval(() => {
      this.AuthenticationTime = this.timeService.getFormattedTime(timer, minutes, seconds);

      if (--timer < 0) {
        clearInterval(this.interval);
        this.refreshTAN();
      }
    }, 1000);
  }

  private refreshTAN() {
    this.hasError = false;
    this.optionService
      .getTAN()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: response => {
          this.tan = response.toString();
          this.interval = this.startTimer();
        },
        error: error => {
          this.hasError = true;
          console.error("Error loading TAN:", error);
        }
      });
  }
}
